<template>
  <div>
    <b-card no-body header-text-variant="dark">
      <div slot="header">
        <context-header
          :title="$t('sidebar.userAdministration')"
          :tab="namedTab">
        </context-header>
      </div>
      <b-tabs card ref="tabs" lazy pills v-model="tabIndex" variant="danger" v-on:input="tabChanged()">
        <b-tab :title="headers[0].title" v-if="hasLocalUserCreatePermission">
          <local-user-management></local-user-management>
        </b-tab>
        <b-tab :title="headers[1].title" v-if="hasUserCreatePermission" ref="tabs" >
          <user-management></user-management>
        </b-tab>
        <b-tab :title="headers[2].title" v-if="hasLocalUserCreatePermission">
          <user-create></user-create>
        </b-tab>
        <b-tab :title="headers[3].title" v-if="hasNotificationPermissions">
          <user-notification></user-notification>
        </b-tab>
        <b-tab :title="headers[4].title" v-if="hasRegistrationReviewAllPermissions">
          <target-public-users></target-public-users>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
  import UserProfile from './user-profile/UserProfile.vue'
  import UserManagement from './user-management/UserManagement.vue'
  import LocalUserManagement from './local-user-management/LocalUserManagement.vue'
  import UserCreate from './user-create/UserCreate.vue'
  import UserNotification from './user-notification/UserNotification.vue'
  import TargetPublicUsers from './target-public-users/TargetPublicUsers.vue'
  import { hasUserCreateClaim, hasLocalUserCreateClaim, hasNotificationCreateClaim, hasRegistrationReviewAllClaim } from '@/router/auth'
  import ContextHeader from '@/components/misc/context-header/ContextHeader'

  export default {
    name: 'user-administration',
    components: {
      ContextHeader,
      'user-profile': UserProfile,
      'user-management': UserManagement,
      'local-user-management': LocalUserManagement,
      'user-create': UserCreate,
      'user-notification': UserNotification,
      'target-public-users': TargetPublicUsers
    },
    data () {
      return {
        headers: [
          { title: this.$t('userAdministration.localAdministration'), value: 'local-administration' },
          { title: this.$t('userAdministration.administration'), value: 'administration' },
          { title: this.$t('userAdministration.userCreate'), value: 'user-create' },
          { title: this.$t('userAdministration.userNotification'), value: 'user-notification' },
          { title: this.$t('userAdministration.targetPublicUsers'), value: 'target-public-users' }
        ],
        tabIndex: 0,
        namedTab: ''
      }
    },
    watch: {
      '$route.query.type' () {
        let type = this.$route.query.type
        if (type && type.length > 0) {
          this.changeTabState(this, this.$refs, type)
          this.namedTab = type
        } else {
          let tabHeader = this.getTabHeader(0).value
          this.changeTabState(this, this.$refs, tabHeader)
          this.namedTab = tabHeader
        }
      }
    },
    created () {
      this.hasUserCreatePermission = hasUserCreateClaim()
      this.hasLocalUserCreatePermission = hasLocalUserCreateClaim()
      this.hasNotificationPermissions = hasNotificationCreateClaim()
      this.hasRegistrationReviewAllPermissions = hasRegistrationReviewAllClaim()
    },
    mounted () {
      let type = this.$route.query.type
      if (type && type.length > 0) {
        this.changeTabState(this, this.$refs, type)
        this.namedTab = type
      } else {
        let state = this.loadTabState(this.$route.path)
        if (state && state.length > 0) {
          // Go to route
          this.$router.replace({path: this.$route.path, query: { ...this.$route.query, type: state }})
        } else {
          this.namedTab = this.getTabHeader(0).value
        }
      }
    },
    methods: {
      tabChanged () {
        let header = this.getTabHeader(this.tabIndex)
        if (header) {
          const param = header.value

          // Save to cookie
          this.saveTabState(this.$route.path, param)
          // Go to route
          this.$router.replace({path: this.$route.path, query: { ...this.$route.query, type: param }})
        }
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
  @import '~@/assets/scss/variables.scss';

  .bg-primary {
    background-color: $primary-color-accent !important;
  }

  .text-dark {
    font-weight: 600;
    font-size: 12pt;
    color: $font-color-dark !important;
  }

</style>



// WEBPACK FOOTER //
// UserAdministration.vue?4a995d09